import { render, staticRenderFns } from "./publishedEformsPage.vue?vue&type=template&id=6d44a4a4&scoped=true&"
import script from "./publishedEformsPage.vue?vue&type=script&lang=ts&"
export * from "./publishedEformsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d44a4a4",
  null
  
)

export default component.exports